<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="6">
          <a-col :span="6">
            <a-form-item label="模板名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input  v-model="queryParam.modelName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  v-model="queryParam.installType" @change="installChange" :allowClear="true">
                <a-select-option  v-for="type in installTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  v-model="queryParam.orderType" :allowClear="true">
                <a-select-option  v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{type.typeName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" style="text-align: right">
            <a-button type="primary" htmlType="submit" @click="queryList(1)">查询</a-button>
            <a-button style="margin-left: 8px" @click="queryKong">清空</a-button>
          </a-col>
        </a-row>
        <a-divider/>
        <a-row>
          <a-col :span="24" style="text-align: right">
            <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        style="margin-top: 20px"
        size="default"
        ref="table"
        showHeader="false"
        :data-source="data"
        :columns="columns"
        :pagination="false"
        bordered
      >
        <span slot="action" slot-scope="text, record">

         <a  @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a  @click="modelDelete(record.id)">删除</a>
        </span>
      </a-table>
      <a-pagination
        showQuickJumper
        showSizeChanger
        :pageSizeOptions="pageSizeOptions"
        :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange"
        :total="total"
        v-model="current"
        @change="getdataList4"
        :showTotal="total => `总共 ${total} 条`"
        style="margin-top: 20px;text-align: end"
      />
    </div>
    <!--<kehuxiadanmoban-modal :queryParam="queryParam"/>-->
    <kehuxiadanmoban-modal ref="modal" @ok="handleOk" :queryParam="queryParam"/>
  </a-card>
</template>

<script>

  // 调接口
  import {customerModelList,customerModelDelete} from '@/api/enterprise/customerModel'
  import kehuxiadanmobanModal from './modules/kehuxiadanmobanModal'
  import EnterpriseCustomizationModal from './modules/EnterpriseCustomizationModal'
  import { checkPermission } from '@/utils/permissions'
  import pick from 'lodash.pick'
  import {getDictMap} from "../../utils/dict";
  // 调接口
  import {getList} from '@/api/order/orderList'
  export default {
    name: 'CustomerOrderTemplate',
    components: {
      kehuxiadanmobanModal
    },
    data () {
      return {
        columns: [
          {
            title: ' 操作',
            dataIndex: 'action',
            width:80,
            scopedSlots: { customRender: 'action' }
          },
          {
            title: '模板名称',
            dataIndex: 'modelName',
            align: 'center'
          },
          {
            title: '创建人',
            dataIndex: 'createBy',
            align: 'center'
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            align: 'center'
          },
          {
            title: '安装类型',
            dataIndex: 'installType',
            align: 'center'
          },
          {
            title: '订单类型',
            dataIndex: 'orderType',
            align: 'center'
          }
        ],
        data:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        // 查询参数
        queryParam: {},
        List :[],
        // 分页
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total:0,
        current:1,
        pageSize:10,
        // 字典为是否
        restaurantTypes:[],
        // 字典为安装类型
        installTypes:[],
        addEnable: checkPermission('enterprise:enterpriseCustomization:add')
        // editEnabel: checkPermission('enterprise:enterpriseCustomizationadd:edit')
      }
    },
    async created(){
      // 字典为安装类型
      this.installTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.installTypes.push({code: key, label: value})
        // console.log(this.installTypes)
      })
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = this.pageSize
      customerModelList(this.queryParam).then(res=>{
        console.log(res.rows)
        this.data=res.rows
        this.total= res.total
      })
    },
    methods: {
      onShowSizeChange(current, pageSize) {
        this.pageSize = pageSize;
        this.queryList(current)
      },
      getdataList4(value = 1) {
        this.queryList(value)
      },
      handleOk(){
        this.queryList(this.current)
      },
      queryList(value){
        this.queryParam.pageNum = value
        this.queryParam.pageSize = this.pageSize
        customerModelList(this.queryParam).then(res=>{
          console.log(res.rows)
          this.data=res.rows
          this.total = res.total
        })
      },
      queryKong(){
        this.queryParam={}
      },
      handleAdd () {
        this.$refs.modal.add()
      },
      handleEdit(record){
        this.$refs.modal.edit(record)
      },
      modelDelete(id){


        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            customerModelDelete({modelId:id}).then(res=>{
              console.log(res)
              if(res.code==0){
                that.$message.success('模板删除成功')
                that.queryList()
              }else{
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });




      },
      async installChange(e){
        this.List = [];
        await getList(e).then(res => {
          if (res.code === 0) {
            this.List = res.rows;
            // console.log(res.rows)
          } else {
            this.$message.error(res.msg);
          }
        })
      },
    }
  }
</script>

<style scoped>
  .twobtn{
    background-color: #169BD5;
    color: white;
    width: 110px;
    font-size: 15px;
  }
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>
